/** 页面信息 */
const page = new (function () {
  this.title = '综合报表'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_statistic_zhbb'
  /**菜单编号 */
  this.code = 'penalize_statistic_zhbb'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/query/zhbb'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
